import React from 'react';
import { Link } from 'react-router-dom';
import hero from './hero.webp'; // Assuming you are using this image somewhere
import Navbar from './Navbar';


function Home() {
  return (
    <section
      id="home"
      className="bg-transparent bsb-hero-1 px-3 vh-100" // Removed bsb-overlay and bsb-hover-pull
    >
      <Navbar />

      <div className="container h-100">
        <div className="row justify-content-center align-items-center h-100">
          <div className="col-12 col-md-10 col-lg-8 col-xl-7 text-center text-light"> {/* Changed text-light to text-dark */}
          <h1 className="display-3 fw-bold mb-3">
          <span className="name">
  Den<span className="rotate-n">i</span>s Getov
</span>
</h1>
            <p className="lead mb-5">Full-Stack Developer</p>
            <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
  {/* Free Consultation button with rounded edges */}
  <a 
  href="#contact" 
  className="btn bsb-btn-3xl btn gap-3 rounded-pill" 
  style={{ 
    color: 'white', 
    borderWidth: '2px', 
    borderStyle: 'solid', 
    borderColor: 'transparent',
    borderRadius: '50px', 
    padding: '10px 25px', 
    background: 'transparent',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0 0 0 2px rgba(255,255,255,0)',
    zIndex: '1'
  }} 
> 
  <span style={{
    position: 'absolute',
    inset: '-2px',
    background: 'linear-gradient(90deg, rgb(243, 64, 154),rgb(224, 85, 155), #FF69B4, #FF69B4)',
    zIndex: '-1',
    borderRadius: '50px'
  }}></span>
  <span style={{
    position: 'absolute',
    inset: '2px',
    background: 'transparent',
    borderRadius: '48px',
    zIndex: '-1'
  }}></span>
  Contact 
</a>

  {/* Learn More button with rounded edges */}
  <a 
    href="#about" 
    className="btn bsb-btn-3xl btn-outline-light no-hover animated-button rounded-pill"
    style={{
      color: "white",
      backgroundColor: "transparent",
      border: "2px solid white",
      position: "relative",
      textDecoration: "none",
      overflow: "hidden",
      borderRadius: "50px",
      padding: "10px 25px",
    }}
  >
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    Learn More
  </a>
</div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
